import React, { useContext } from 'react';
import SilverstripeContext from '@/components/context/Silverstripe';
import { useAuthState } from '@/components/context/AuthContext';
import { staticData } from '@/data';
import PureMenu from './PureMenu';

const { regions } = staticData;

const Menu = (props) => {
  const { menuTitle, ...rest } = props;
  const {
    global: { siteConfig, countryStates },
  } = useContext(SilverstripeContext);

  const auth = useAuthState();

  // don't show menu if no global state. likely not been populated
  if (!siteConfig && !countryStates) {
    return null;
  }

  const allCountryState = {
    edges: [],
  };
  countryStates.map((countryState) => allCountryState.edges.push({ node: countryState }));

  return (
    <PureMenu
      {...rest}
      menuTitle={menuTitle}
      auth={auth}
      groupedRegions={allCountryState}
      regionsList={regions}
    />
  );
};

export default Menu;
